// Shared pricing helpers for the proposal forms (ByProjectForm,
// MilestoneMultiForm). Keeping the fee rate and currency formatting in one
// place means every screen that shows "amount / charge / you'll receive"
// computes it the same way.

export const SERVICE_FEE_RATE = 0.15;

const CURRENCY_LABELS = {
  "1": "BDT",
  "2": "USD",
  "3": "AED",
};

export const getCurrencyLabel = (currencyCode) =>
  CURRENCY_LABELS[currencyCode] || "";

// Splits a gross amount into { charge, receiveAmount } using the platform
// fee rate above. `gross` is whatever the client is quoted (budget, or the
// sum of all milestones) — the freelancer receives gross minus the charge.
export const splitByServiceFee = (gross) => {
  const numericGross = Number.isFinite(gross) ? gross : parseFloat(gross) || 0;
  const charge = numericGross * SERVICE_FEE_RATE;
  return {
    gross: numericGross,
    charge,
    receiveAmount: numericGross - charge,
  };
};

export const formatCurrencyAmount = (amount, currencyCode) => {
  const numeric = Number.isFinite(amount) ? amount : parseFloat(amount) || 0;
  const formatted = numeric.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const label = getCurrencyLabel(currencyCode);
  return label ? `${label} ${formatted}` : formatted;
};
